import { useState, useEffect } from "react";
import { useGetAllFacultyQuery } from "src/services/FacultyService";

const useFaculty = () => {
    const [faculty, setFaculty] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllFacultyQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setFaculty(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { faculty, isDataLoading };
};

export default useFaculty;
